import { FC } from 'react';
import { PermissionsGate } from '@kontentino/react-permissions-gate';
import { Button, ButtonProps, Tooltip } from '@kontentino/ui';

type Props = {
  scopes: string | string[];
  tooltipContent?: string;
} & ButtonProps;

const PermissionsGateButton: FC<Props> = ({
  children,
  scopes,
  tooltipContent,
  ...buttonProps
}) => {
  const button = <Button {...buttonProps}>{children}</Button>;

  return (
    <PermissionsGate scopes={scopes}>
      {tooltipContent ? (
        <Tooltip content={tooltipContent}>{button}</Tooltip>
      ) : (
        button
      )}
    </PermissionsGate>
  );
};

export default PermissionsGateButton;
